import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { cn } from '../lib/utils';
import { bonuses, type BonusAccent } from '../data/system';
const accentStyles: Record<BonusAccent, {
  badge: string;
  dot: string;
}> = {
  electric: {
    badge: 'bg-electric/10 text-electric-deep',
    dot: 'bg-electric'
  },
  perf: {
    badge: 'bg-perf/15 text-perf-deep',
    dot: 'bg-perf'
  },
  ember: {
    badge: 'bg-ember/20 text-ember-deep',
    dot: 'bg-ember'
  },
  aqua: {
    badge: 'bg-aqua/15 text-aqua-deep',
    dot: 'bg-aqua'
  }
};
export function Bonuses() {
  return <section aria-label="Bonuslar" className="bg-white" data-id="element-18" data-mp="3o1lf0qlfzjix">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "21px"
    }} data-id="element-19" data-mp="3o3680bs3yueo">
        <div className="text-center" data-id="element-20" data-mp="3t2sm0nfrgeoj">
          <p className="inline-flex items-center gap-1.5 rounded-full bg-ember/20 px-3 py-1 text-xs font-bold uppercase tracking-wider text-ember-deep" data-id="element-21" data-mp="1m9qhrfzxnhk8">
            Bugüne özel teklif
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-6xl" data-id="element-22" data-mp="3ie6ef7ea3jqx">
            4 bonus hediye
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-navy/65" data-id="element-23" data-mp="3df3cvwxibvnp">
            Ana ürününüzle birlikte dört dijital bonus da ek ücret ödemeden sunulur.
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-24" data-mp="3n5oiw5fig2gn">
          {bonuses.map((b, i) => {
          const a = accentStyles[b.accent];
          return <motion.article key={b.n} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: i % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-2xl border border-navy/10 bg-warm p-5 sm:p-6" data-id="element-25" data-mp="2zhez191uxos5" data-mpi={i}>
                <div className="flex gap-4 sm:gap-5" data-id="element-26" data-mp="ir6ty1nm5maf">
                  <img src={b.cover} alt={`${b.title} kapağı`} width={1122} height={1402} loading="lazy" decoding="async" className="h-auto w-24 shrink-0 self-start drop-shadow-[0_12px_16px_rgba(16,28,44,0.25)] sm:w-32" data-id="element-27" data-mp="iqf12ylei2nu" />
                  <div className="min-w-0 flex-1" data-id="element-28" data-mp="3hju8l027a9jl">
                    <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-29" data-mp="3lknxnwrdpue2">
                      <span className={cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-bold', a.badge)} data-id="element-30" data-mp="3qixtm9kxgz0q">
                        <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-31" data-mp="2tqc3rns346mq" /> Bonus {b.n}
                      </span>
                      <span className="whitespace-nowrap text-sm font-bold" data-id="element-32" data-mp="32t3h5t4itch0">
                        <span className="text-navy/40 line-through" data-id="element-33" data-mp="32r0i6jle4905">{b.price}</span>{' '}
                        <span className="text-perf-deep" data-id="element-34" data-mp="37l4qb66e6n2t">ÜCRETSİZ</span>
                      </span>
                    </div>
                    <h3 className="mt-3 font-display text-xl font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-35" data-mp="2f3ivv3kwa34k">
                      {b.title}
                    </h3>
                    <p className="mt-1.5 text-sm font-semibold leading-snug text-navy/65" data-id="element-36" data-mp="27hx631ma424k">{b.subtitle}</p>
                  </div>
                </div>
                <div className="mt-4 space-y-2 text-sm leading-relaxed text-navy/70" data-id="element-37" data-mp="1xl28ckxty5rc">
                  {b.desc.map(d => <p key={d} data-id="element-38" data-mp="1tl090ifkhof8">{d}</p>)}
                </div>
                <div className="mt-auto pt-5" data-id="element-39" data-mp="1tml3y95sn9dm">
                  <p className="text-xs font-semibold text-navy/55" data-id="element-40" data-mp="1om70l4f50nlx">{b.tagsLabel}</p>
                  <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-41" data-mp="1ju5hozngrymx">
                    {b.tags.map(t => <li key={t} className="inline-flex items-center gap-1.5 rounded-md border border-navy/10 bg-white px-2 py-1 text-xs font-medium text-navy/75" data-id="element-42" data-mp="1ev2ms81778so">
                        <span className={cn('h-1.5 w-1.5 rounded-full', a.dot)} aria-hidden="true" data-id="element-43" data-mp="19u6b38aluicp" />
                        {t}
                      </li>)}
                  </ul>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-10 rounded-2xl bg-navy px-6 py-8 text-center text-white sm:px-10" data-id="element-44" data-mp="30xke3hmo96ra">
          <p className="font-display text-2xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-45" data-mp="34zxia1lrswly">
            4 bonus — <span className="text-perf" data-id="element-46" data-mp="2r8sohg532yjj">bugün ücretsiz</span>
          </p>
          <p className="mt-2 text-sm text-white/65" data-id="element-47" data-mp="2w6u9i6m2l7xn">
            Toplam bonus değeri: <span className="line-through" data-id="element-48" data-mp="2w4zq4wqg5nvo">5.920 TRY</span>
          </p>
          <p className="mx-auto mt-6 max-w-2xl text-sm text-white/70" data-id="element-49" data-mp="2h89zy82kqtva">
            UZUN MESAFE TRİATLON SİSTEMİ™ ile yalnızca ana ürünü değil, hazırlığınızı organize etmenize yardımcı olacak dört ek aracı da elde edersiniz.
          </p>
          <p className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 font-display text-2xl font-bold uppercase tracking-wide" data-id="element-50" data-mp="2d887mpiqbcso">
            <span data-id="element-51" data-mp="6itjnfjc55l5">Planla</span>
            <span className="text-electric" aria-hidden="true" data-id="element-52" data-mp="6fpas4uxdlo5">→</span>
            <span data-id="element-53" data-mp="bfk2gamiyfa9">Beslen</span>
            <span className="text-electric" aria-hidden="true" data-id="element-54" data-mp="besf1n32znv2">→</span>
            <span data-id="element-55" data-mp="lllc2rehvbav">Hazırlan</span>
            <span className="text-electric" aria-hidden="true" data-id="element-56" data-mp="liflf7q7w1d1">→</span>
            <span data-id="element-57" data-mp="gna0oc8jwsqj">Takip et</span>
          </p>
          <p className="mt-4 text-xs text-white/55" data-id="element-58" data-mp="ucvbv0g403o0">
            Dört bonusun tamamı, ana ürünle birlikte ek ücret ödemeden sunulur.
          </p>
        </div>
      </div>
    </section>;
}